import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../stories/Title/Title";
import Close from "../../../images/Close.svg";
import { ActiveType, LicenseTypes, Operation } from "../../../utils/Enum.types";
import { LabelProps } from "../../../utils/types";
import { Label } from "../../../stories/Label/Label";
import { Form, Formik, FormikProps } from "formik";
import {
  CustomerFormType,
  PredefinedDataTypes
} from "../../../utils/formTypes";
import { customerValidation } from "../../../utils/validationSchema";
import InputHoc from "../../common/Input/Index";
import TextArea from "../../../stories/TextArea/TextArea";
import InputNumber from "../../common/Input/InputNumber";
import { Button } from "../../../stories/Button/Button";
import {
  AddCustomer as AddCustomerMutation,
  UpdateCustomer
} from "./queries/mutations";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  AddCustomerResult,
  AddCustomerVar,
  MstCustomer,
  MstCustomerOrderField,
  UpdateCustomerResult,
  UpdateCustomerVar
} from "./queries/types";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE
} from "../../../utils/constants";

import useLoggedInUserDetails from "../../../customHooks/useLoggedInUserDetails";
import {
  handleFormEvent,
  handleMUISelectEvent,
  removeMoreSpace
} from "../../../utils/UtilFunctions";
import MessageModal from "../../../customComponents/MessageModal";
import { AppContext } from "../../../context/context";
import { GetCustomerByNodeId, GetCustomers } from "./queries/queries";
import { nodeVar, OrderDirection } from "../../../utils/commonQueryTypes";
import { modalOpertaionFlag } from "./Index";
import PhoneInput from "react-phone-input-2";
import { Keys } from "../../../utils/Enum.keys";
import PredefinedAutocomplete from "../../../customComponents/PredefinedAutocmplete";
import LoadingModal from "../../pages/LoadingModal";
import GstInputComponent from "../../common/Input/GstInputComponent";
import StatesAutocomplete from "../../../customComponents/States";
import { PredefinedDataByTypeEdge } from "../../../queries/types";
import Navbar from "../../common/layout/Navbar";
import Steps from "./Steps";
import { useNavigate } from "react-router-dom";
import PredefinedSelect from "../../../customComponents/PredefinedSelect";
import useFormJson from "../../../json/useFormJson";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<modalOpertaionFlag>>;
  operation: Operation;
}

const AddCustomer = ({ setModalFlag, operation }: Props) => {
  const [message, setMessage] = useState(emptyMessage);
  const { customerformLabels } = useFormJson();
  const navigate = useNavigate();

  const { state } = useContext(AppContext);
  const emptyFormData: CustomerFormType = {
    address: "",
    contactPerson: "",
    contactPersonDesign: "",
    country: "",
    email: "",
    mobile: "",
    name: "",
    pin: "",
    place: "",
    state: "",
    url: "",
    gstNo: "",
    panNo: "",
    gstStateCode: ""
  };
  const [formData, setFormData] = useState<CustomerFormType>(emptyFormData);
  const { user_details } = useLoggedInUserDetails();
  const [gstCode, setGstCode] = useState(EMPTY_STRING);
  const [errorMessage, setErrorMessage] = useState(EMPTY_STRING);

  const [GetCustomerById, { data, loading }] = useLazyQuery<
    { node: MstCustomer },
    nodeVar
  >(GetCustomerByNodeId);
  const [AddCustomerDetails, { loading: AddCustomerMutationLoading }] =
    useMutation<AddCustomerResult, AddCustomerVar>(AddCustomerMutation, {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE
        });
      }
    });

  const [UpdateCustomerDetails, { loading: UpdateCustomerLoading }] =
    useMutation<UpdateCustomerResult, UpdateCustomerVar>(UpdateCustomer, {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE
        });
      }
    });

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<CustomerFormType>
  ) => {
    const { name, value } = e.target as HTMLInputElement;
    let finalValue = "";
    if (e.target.name === "gstNo") {
      finalValue = value.toLocaleUpperCase();
    } else {
      finalValue = value;
    }
    setFormData(() => ({
      ...formData,
      [name]: finalValue
    }));
    meta.handleChange(e);
  };
  const handleSubmit = async () => {
    if (operation === Operation.CREATE) {
      const customerAdded = AddCustomerDetails({
        variables: {
          
          user_details,
          input: {
            address: removeMoreSpace(formData.address),
            contactPerson: removeMoreSpace(formData.contactPerson),
            name: removeMoreSpace(formData.name),
            place: removeMoreSpace(formData.place),
            contactPersonDesign: formData.contactPersonDesign,
            country: formData.country,
            email: formData.email,
            gstNo: (formData.gstStateCode + formData.gstNo) as string,
            isActive: ActiveType.CURR,
            logoFilename: EMPTY_STRING,
            mobile:
              formData.mobile.length === 12
                ? `+${formData.mobile}`
                : EMPTY_STRING,
            panNo: formData.panNo as string,
            pin: formData.pin,
            state: formData.state,
            url: formData.url
          }
        },
        refetchQueries: [
          {
            query: GetCustomers,
            variables: {
              after: null,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: MstCustomerOrderField.NAME
              },
              name: EMPTY_STRING,
              
            }
          }
        ]
      });
      const { data } = await customerAdded;

      if (data && data.AddCustomer) {
        setMessage({
          flag: true,
          message: "Customer added successfully",
          operation: Operation.CREATE
        });
        navigate(`/${data.AddCustomer.id}/addfinancialyear`);
      }
    } else {
      const customerUpdated = UpdateCustomerDetails({
        variables: {
          
          user_details,
          id: state.customerId,
          input: {
            address: removeMoreSpace(formData.address),
            contactPerson: removeMoreSpace(formData.contactPerson),
            name: removeMoreSpace(formData.name),
            place: removeMoreSpace(formData.place),
            contactPersonDesign: formData.contactPersonDesign,
            country: formData.country,
            email: formData.email,
            gstNo: formData.gstStateCode + formData.gstNo,
            isActive: ActiveType.CURR,
            logoFilename: EMPTY_STRING,
            mobile:
              formData.mobile.length === 12
                ? `+${formData.mobile}`
                : EMPTY_STRING,
            panNo: formData.panNo,
            pin: formData.pin,
            state: formData.state,
            url: formData.url
          }
        },
        refetchQueries: [
          {
            query: GetCustomers,
            variables: {
              after: null,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: MstCustomerOrderField.NAME
              },
              name: EMPTY_STRING,
              
            }
          }
        ]
      });
      const { data } = await customerUpdated;

      if (data && data.UpdateCustomer) {
        setMessage({
          flag: true,
          message: "Customer details updated successfully",
          operation: Operation.CREATE
        });
      }
    }
  };

  const hanldeClear = () => {
    const inputElement = document.getElementsByName(
      'name'
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();
    setFormData(emptyFormData);
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    if (message.operation !== Operation.NONE) {
      hanldeClear();
      setModalFlag({
        flag: false,
        operation: Operation.CREATE
      });
    }
  };

  useEffect(() => {
    if (operation === Operation.UPDATE) {
      GetCustomerById({
        variables: {
          id: state.customerId,
          
        }
      }).then(({ data }) => {
        if (data && data.node) {
          const gstStateCode = data.node.gstNo.slice(0, 2);
          const gst = data.node.gstNo.slice(2, data.node.gstNo.length);

          setFormData({
            address: data.node.address,
            contactPerson: data.node.contactPerson,
            contactPersonDesign: data.node.contactPersonDesign,
            country: data.node.country,
            email: data.node.email,
            gstNo: gst,
            mobile: data.node.mobile.replace("+", ""),
            name: data.node.name,
            panNo: data.node.panNo,
            pin: data.node.pin,
            place: data.node.place,
            state: data.node.state,
            url: data.node.url,
            gstStateCode
          });
        }
      });
    }
  }, [operation, GetCustomerById, state.customerId, data]);

  const handleNumberChange = (name: string, value: string) => {
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleAutcompleteChange = (name: string, value: string) => {
    setFormData({
      ...formData,
      [name]: value
    });
  };

  return (
    <>
      {operation === Operation.CREATE && (
        <>
          <Navbar NavType={LicenseTypes.CUSTOMER} />
          <Title>
            {operation === Operation.CREATE ? "Add" : "Update"} Customer
          </Title>
          <Steps step={1} />
        </>
      )}
   {operation === Operation.UPDATE && (
                  <div className="customer__add--title">
                    <Title>Update Customer</Title>
                    <img
                      src={Close}
                      alt=""
                      onClick={() => {
                        hanldeClear();
                        setModalFlag({
                          flag: false,
                          operation: Operation.CREATE
                        });
                      }}
                    />
                  </div>
                )}
      <Formik
        initialValues={formData}
        validationSchema={customerValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <div
              className={
                operation === Operation.CREATE ? `customer` : `customer__add`
              }
            >
              <Form className={`customer__add--${operation === Operation.UPDATE ? "edit":"form"}`}>
             
                  <div className="customer__add--form-head">
                    <h4>Customer Details</h4>
                  </div>
                  <div className="customer__add--form-details row g-0">
                    <div className="col h-100">
                      {customerformLabels.leftForm.map(
                        (field: LabelProps, key: React.Key) => {
                          if (field.dataType === "textarea") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                />
                                {meta.touched &&
                                meta.errors[field.inputName] ? (
                                  <div className="label-grid">
                                    <span />
                                    <span className="nodata">
                                      {meta.errors[field.inputName]}
                                    </span>
                                  </div>
                                ) : null}
                              </div>
                            );
                          } else if (field.dataType === "number") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  onKeyDown={handleFormEvent}
                                  name={field.inputName}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                />
                                {meta.touched &&
                                meta.errors[field.inputName] ? (
                                  <div className="label-grid">
                                    <span />
                                    <span className="nodata">
                                      {meta.errors[field.inputName]}
                                    </span>
                                  </div>
                                ) : null}
                              </div>
                            );
                          } else if (field.dataType === "state") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <PredefinedSelect
                                  label=""
                                  onChange={(e, state_code) => {
                                    setFormData({
                                      ...formData,
                                      state: e,
                                      gstStateCode: state_code
                                        ? state_code
                                        : EMPTY_STRING,
                                    });
                                  }}
                                  type={PredefinedDataTypes.STATE}
                                  value={formData.state as string}
                                  name={field.inputName as string}
                                />
                              </div>
                            );
                          } else if (field.dataType === "city") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <PredefinedSelect
                                  label=""
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      place: e,
                                    });
                                  }}
                                  type={PredefinedDataTypes.CITY}
                                  value={formData.place as string}
                                  name={field.inputName as string}
                                />
                              </div>
                            );
                          } else if (field.dataType === "country") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <PredefinedSelect
                                  label=""
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      country: e,
                                    });
                                  }}
                                  type={PredefinedDataTypes.COUNTRY}
                                  value={formData.country as string}
                                  name={field.inputName as string}
                                />
                              </div>
                            );
                          } else {
                            return (
                              <React.Fragment key={key}>
                                <InputHoc
                                  LabelName={field.labelName}
                                  values={formData[field.inputName]}
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  required={field.required}
                                  autoFocus={field.autoFocus}
                                  autoComplete="off"
                                />
                                {meta.touched &&
                                meta.errors[field.inputName] ? (
                                  <div className="label-grid">
                                    <span />
                                    <span className="nodata">
                                      {meta.errors[field.inputName]}
                                    </span>
                                  </div>
                                ) : null}
                              </React.Fragment>
                            );
                          }
                        }
                      )}
                    </div>
                    <div className="col h-100">
                      {customerformLabels.rightForm.map(
                        (field: LabelProps, key: React.Key) => {
                          if (field.dataType === "textarea") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  required={field.required}
                                />
                                {meta.touched &&
                                meta.errors[field.inputName] ? (
                                  <div className="label-grid">
                                    <span />
                                    <span className="nodata">
                                      {meta.errors[field.inputName]}
                                    </span>
                                  </div>
                                ) : null}
                              </div>
                            );
                          } else if (field.dataType === "number") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                />
                                {meta.touched &&
                                meta.errors[field.inputName] ? (
                                  <div className="label-grid">
                                    <span />
                                    <span className="nodata">
                                      {meta.errors[field.inputName]}
                                    </span>
                                  </div>
                                ) : null}
                              </div>
                            );
                          } else if (field.inputName === "mobile") {
                            return (
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <PhoneInput
                                  country={"in"}
                                  value={formData[field.inputName] as string}
                                  onChange={(e: string) => {
                                    handleNumberChange(field.inputName, e);
                                  }}
                                  inputProps={{
                                    required: true,
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === Keys.ENTER) {
                                      e.preventDefault();
                                      handleMUISelectEvent(e);
                                    }
                                  }}
                                />
                              </div>
                            );
                          } else if (field.dataType === "gstNo") {
                            return (
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <GstInputComponent
                                  state_code={formData.gstStateCode}
                                  values={formData[field.inputName] as string}
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  required={field.required}
                                  max={field.maxLength ? field.maxLength : 20}
                                />
                                {meta.touched &&
                                meta.errors[field.inputName] ? (
                                  <div className="label-grid">
                                    <span />
                                    <span className="nodata">
                                      {meta.errors[field.inputName]}
                                    </span>
                                  </div>
                                ) : null}
                              </div>
                            );
                          } else
                            return (
                              <React.Fragment key={key}>
                                <InputHoc
                                  LabelName={field.labelName}
                                  values={formData[field.inputName]}
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  required={field.required}
                                />
                                {meta.touched &&
                                meta.errors[field.inputName] ? (
                                  <div className="label-grid">
                                    <span />
                                    <span className="nodata">
                                      {meta.errors[field.inputName]}
                                    </span>
                                  </div>
                                ) : null}
                              </React.Fragment>
                            );
                        }
                      )}
                    </div>
                  </div>
               
                  <Button mode="save" type="submit" />
                  {operation === Operation.CREATE ? (
                    <>
                      <Button mode="clear" type="reset" onClick={hanldeClear} />
                      <Button mode="back" onClick={() => navigate(-1)} />
                    </>
                  ) : (
                    <Button
                      mode="cancel"
                      type="button"
                      onClick={() => {
                        setModalFlag({
                          flag: false,
                          operation: Operation.CREATE,
                        });
                      }}
                    />
                  )}
              </Form>
            </div>
          );
        }}
      </Formik>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal
        flag={loading || AddCustomerMutationLoading || UpdateCustomerLoading}
      />
    </>
  );
};

export default AddCustomer;
